var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 22,
  style: {
    isolation: "isolate"
  },
  viewBox: "0 0 25 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_vxkWHEP7HyoA2e7czNGbyDyr4pO2i9yc"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h25v22H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_vxkWHEP7HyoA2e7czNGbyDyr4pO2i9yc)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeMiterlimit: 4,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  id: "!",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  d: "M24 16v3.5c0 .828-1.103 1.5-2.464 1.5H3.464C2.103 21 1 20.328 1 19.5V16",
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  id: "!",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.873 11 12.5 15.67 8.127 11",
  vectorEffect: "non-scaling-stroke"
}), /*#__PURE__*/React.createElement("path", {
  id: "!",
  strokeLinecap: "square",
  strokeLinejoin: "miter",
  d: "M12.5 1.412v13.176",
  vectorEffect: "non-scaling-stroke"
})))));
export default SvgDownload;